import Seo, { SEO } from '../components/Seo';

export default function PrivacyPolicy() {
  return (
    <>
      <Seo {...SEO.privacy} />
    <div className="pt-28 pb-20 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-400 mb-10">Last updated: May 14, 2026</p>

        <div className="space-y-8 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Introduction</h2>
            <p>
              PixelUtility ("we", "us", or "our") operates the website pixelutility.com. This Privacy Policy explains how we collect, use, and protect your information when you use our website and tools.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Information We Collect</h2>
            <p className="mb-3">We collect minimal information to operate our services:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Usage Data:</strong> We use Google Analytics to collect anonymous usage statistics such as pages visited, time spent on pages, browser type, and device information. This data is aggregated and cannot identify you personally.</li>
              <li><strong>Cookies:</strong> We use cookies for analytics (Google Analytics) and advertising (Google AdSense). You can control cookies through your browser settings.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Local Processing</h2>
            <p>
              Many of our tools process your files entirely in your browser. This means your files (resumes, images, PDFs, etc.) are never uploaded to our servers. They remain on your device at all times.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Third-Party Services</h2>
            <p className="mb-3">We use the following third-party services:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Google Analytics:</strong> For website usage statistics. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">Google's Privacy Policy</a></li>
              <li><strong>Google AdSense:</strong> For displaying relevant advertisements. Google may use cookies to serve ads based on your prior visits. <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">How Google uses data</a></li>
              <li><strong>Buy Me a Coffee:</strong> For processing voluntary support contributions. Their own privacy policy applies to any transactions.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Advertising</h2>
            <p>
              We display advertisements through Google AdSense. Third-party vendors, including Google, use cookies to serve ads based on your prior visits to this website or other websites. You may opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">Google Ads Settings</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Data Retention</h2>
            <p>
              We do not store any personal data on our servers. Analytics data is retained by Google according to their data retention policies. Files processed by our tools are never stored or transmitted — they exist only in your browser's memory during use.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Your Rights</h2>
            <p className="mb-3">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Disable cookies through your browser settings</li>
              <li>Opt out of Google Analytics tracking using the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">Google Analytics Opt-out Browser Add-on</a></li>
              <li>Opt out of personalized ads via Google Ads Settings</li>
              <li>Request information about any data we hold (we hold none)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Children's Privacy</h2>
            <p>
              Our services are not directed to children under 13. We do not knowingly collect personal information from children.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:info@pixelutility.com" className="text-brand-600 hover:underline">info@pixelutility.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
    </>
  );
}
